module.exports = __webpack_public_path__ + "static/media/msg-click.36aaa198.svg";